import router from '@/routes';
import {
  getDedicatedReportRouteName,
  resolveReportTypeFromRoute,
} from '@/views/reports/report-route-behavior';

export const reportTypeFromRoute = () => {
  const { name, params } = router.currentRoute.value;

  return resolveReportTypeFromRoute(name, params.type as string);
};

export const reportTypeFromMetricName = (metric: string) => {
  return getDedicatedReportRouteName(metric);
};
